// extracted by mini-css-extract-plugin
export default {"infoRow":"InfoRow_infoRow__fbUh3","textLabel":"InfoRow_textLabel__1wkLW"};